/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface UpdateAccountPbIds$Request {
    accountId: number;
    requestBody: Array<string>;
}

export interface UpdateAccountPbIds$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateAccountPbIdsRequest = createAction<PayloadData<void, UpdateAccountPbIds$Request>>('UPDATE_ACCOUNT_PB_IDS__UPDATE_ACCOUNT_PB_IDS__REQUEST');
export const updateAccountPbIdsSuccess = createAction<PayloadData<void, UpdateAccountPbIds$Request>>('UPDATE_ACCOUNT_PB_IDS__UPDATE_ACCOUNT_PB_IDS__SUCCESS');
export const updateAccountPbIdsFailure = createAction<PayloadData<Error, UpdateAccountPbIds$Request, true>>('UPDATE_ACCOUNT_PB_IDS__UPDATE_ACCOUNT_PB_IDS__FAILURE');

export const updateAccountPbIdsActions = [
    updateAccountPbIdsRequest,
    updateAccountPbIdsSuccess,
    updateAccountPbIdsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {Array<string>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateAccountPbIds = (meta: UpdateAccountPbIds$Request, config?: UpdateAccountPbIds$Config) => {
    return {
        CALL_API: {
            types: updateAccountPbIdsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/pb-ids`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

